/** =========================================================
 * Module: items-reorder.directive.js
 * Data items reorder
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemsReorder', itemsReorder);

  itemsReorder.$inject = [];

  function itemsReorder() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/components/items-reorder.html',
      link: link,
      scope: {
        config: '='
      }
    };

    return directive;

    function link($scope) {
      if ($scope.config && $scope.config.model && $scope.config.getData && $scope.config.getDataParams) {
        $scope.orderFields = $scope.config.fields.filter(function (field) {
          return field.order === true || field.sort === true;
        });

        if ($scope.config.getDataParams.order) {
          $scope.field = Object.keys($scope.config.getDataParams.order)[0];
          $scope.direction = $scope.config.getDataParams.order[$scope.field];
        } else if ($scope.config.getDataParams.sort) {
          $scope.field = Object.keys($scope.config.getDataParams.sort)[0];
          $scope.direction = $scope.config.getDataParams.sort[$scope.field];
        }

        $scope.reorder = function (fieldKey) {
          try {
            var type;
            var data = {};
            var field = $scope.config.fields.filter(function (item) { return item.key === fieldKey; })[0];

            $scope.direction = $scope.direction === 'asc' ? 'desc' : 'asc';

            if (field.order) {
              type = 'order';
              delete $scope.config.getDataParams.sort;
            }

            if (field.sort) {
              type = 'sort';
              delete $scope.config.getDataParams.order;
            }

            data[fieldKey] = $scope.direction;

            $scope.config.getDataParams[type] = data;
            $scope.config.getDataParams.page = 1;
            $scope.config.getData();
          } catch (error) {
            Raven.captureException(error);
          }
        };
      }
    }
  }
})();
